import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { QueueHeaderComponent } from "@shared-core/general/queue/layout/queue-header/queue-header.component";
import { QueueFooterComponent } from "@shared-core/general/queue/layout/queue-footer/queue-footer.component";

/**
 * Layout shell for authenticated customer pages.
 * Renders the brand header, a router outlet, and the location footer.
 */
@Component({
  selector: "app-queue-layout",
  standalone: true,
  imports: [RouterOutlet, QueueHeaderComponent, QueueFooterComponent],
  templateUrl: "./queue-layout.component.html",
  styleUrl: "./queue-layout.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QueueLayoutComponent {}
